export const requiredKloopifyFields = [
  { field: "date", label: "Date" },
  { field: "supplierName", label: "Supplier Name" },
  { field: "totalCost", label: "Total Cost" },
  { field: "itemName", label: "Commodity Name" },
  { field: "costCenter", label: "Cost Center" }
];
